import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <img src="/logo-mark.png" alt="" className="footer-logo-mark" />
            Kari Mash<span>.</span>
          </Link>
          <p className="footer-tagline">Thoughts, ideas & everything in between.</p>
        </div>

        <div className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/about">About</Link>
        </div>

        <SocialLinks className="footer-social" />
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Kari Mash. All rights reserved.</span>
        <span className="footer-credit">Made with care & too much tea.</span>
      </div>
    </footer>
  );
}
